import { render, staticRenderFns } from "./PartnerAccordionItem.vue?vue&type=template&id=167fc4f0&scoped=true&"
import script from "./PartnerAccordionItem.vue?vue&type=script&lang=js&"
export * from "./PartnerAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fc4f0",
  null
  
)

export default component.exports